// Route validation must not load the Pool detail UI before its lazy route opens.
export const POOL_TABS = ["overview", "nodes", "routing"] as const;
export type PoolTab = (typeof POOL_TABS)[number];
/** Former tabs, now sections of the Overview. */
export const POOL_MOVED = ["utilization", "approvals", "forecast", "recommendations"];
